import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=857421c0&scoped=true"
import script from "./AddPlan.vue?vue&type=script&lang=js"
export * from "./AddPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857421c0",
  null
  
)

export default component.exports